// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__adCiT","Headline":"style_Headline__P2dIN","icon":"style_icon__ddaCX"};